export default __webpack_public_path__ + "static/media/landingImage.557d28bc.png";